import React, { useState } from 'react';
import { getInboxMailList, getRawEmailContent, searchEmails } from '../../utils/awsAPI';
import { useDispatch, useSelector } from 'react-redux';
import { emailSliceAction } from '../../store/emailSlice';
import { Spinner } from 'react-bootstrap';
import emptybox from "./../../assets/images/empty-box.png";

const InboxMailList = () => {
    const dispatch = useDispatch()
    const selectedContact = useSelector((state: any) => { return state.emailSlice.selectedContact })
    const lastEvaluatedKey = useSelector((state: any) => { return state.emailSlice.lastEvaluatedKey })
    const workmailDomain = useSelector((state: any) => { return state.emailSlice.workmailDomain })

    const inboxList = useSelector((state: any) => { return state.emailSlice.inboxList })

    const [searchKey, setSearchKey] = useState<any>("")
    const emailLoading = useSelector((state: any) => { return state.emailSlice.emailLoading })
    const [emailListloading, setEmailListLoading] = useState<any>(false);

    const getEmailView = async (mail: any) => {
        dispatch(emailSliceAction.setEmailLoading(true))
        let contactId = mail?.MessageId2;
        dispatch(emailSliceAction.setSelectedContact(contactId))
        let messageId = mail?.MessageId2;
        let workmailDomain = mail?.WorkmailDomain;
        let result = await getRawEmailContent('inbox', messageId, workmailDomain)
        if (result.success === true) {
            dispatch(emailSliceAction.setEmailDetails(result.data))
        } else {
            dispatch(emailSliceAction.setEmailDetails(""))
        }
        dispatch(emailSliceAction.setEmailLoading(false))
    }

    const onSearch = async (event: any) => {
        dispatch(emailSliceAction.setInboxList([]))
        setEmailListLoading(true)
        let inputData = (event.target.value);
        setSearchKey(inputData)
        if (inputData === '') {
            let data = await getInboxMailList(workmailDomain, 'inbox', '')
            if (data.success) {
                dispatch(emailSliceAction.setInboxList(data?.data?.body?.Items))
            }
        } else {
            let data = await searchEmails(inputData, workmailDomain, 'inbox')
            if (data.success) {
                dispatch(emailSliceAction.setInboxList(data?.data?.body?.Items))
            }
        }

        setEmailListLoading(false)
    }

    const showMore = async () => {
        setEmailListLoading(true)
        let result = await getInboxMailList(workmailDomain, 'inbox', lastEvaluatedKey)
        if (result.success) {
            let existingData = inboxList
            let newData = result?.data?.body?.Items
            var updatedData = [...existingData, ...newData];
            dispatch(emailSliceAction.setInboxList(updatedData))
            dispatch(emailSliceAction.setWorkmailDomain(workmailDomain))
            dispatch(emailSliceAction.setLastEvaluatedKey(result?.data?.body?.LastEvaluatedKey))
        } else {
            dispatch(emailSliceAction.setLastEvaluatedKey(""))
        }
        setEmailListLoading(false)
    }

    return (
        <React.Fragment>
            <div className="card wrapup-box collapse show mt-3" id="ChatUser">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className='m-0'>Inbox</h6>
                </div>
                <div className="card-body height-400">
                    <div className='row'>
                        {(inboxList.length > 0 && !emailLoading) &&
                            <div className='col-12 email-search-sticky bg-white mb-2'>
                                <div className="input-group mt-2 mb-2">
                                    <input type="text" onChange={(event) => { onSearch(event) }} value={searchKey} className="form-control" placeholder="Search" />
                                </div>
                            </div>
                        }
                        {(inboxList.length > 0 && !emailLoading) &&
                            <div className='col-12'>
                                <ul className='list-unstyled m-0'>
                                    {inboxList.map((email: any, index: number) => {
                                        let userChar = email?.Sender.substring(0, 1).toUpperCase()
                                        let userName = (email?.Sender.length > 18 ? email?.Sender.substring(0, 18) + '...' : email?.Sender)
                                        let subject = (email?.Subject.length > 18 ? email?.Subject.substring(0, 18) + '...' : email?.Subject)
                                        let messageId = email?.MessageId2
                                        return (
                                            <li key={index} className={`${(selectedContact === messageId) ? "active_contacts" : "inactive_contacts"}`}>
                                                <button onClick={() => { getEmailView(email) }} className='chat-user-box'>
                                                    <div className='chat-user-icon'>
                                                        {userChar}
                                                    </div>
                                                    <div className='chat-user-name'>
                                                        <div className='chuser-name'>{userName}</div>
                                                        <div className='chuser-msg'>{subject}</div>
                                                    </div>
                                                </button>
                                            </li>
                                        )
                                    })}
                                    {(lastEvaluatedKey && searchKey === '') &&
                                        <li>
                                            <button onClick={() => { showMore() }} className='chat-user-box'>
                                                Show more
                                            </button>
                                        </li>
                                    }
                                </ul>
                            </div>
                        }
                    </div>
                        {(emailListloading || emailLoading) ? <Spinner className='spinner-center' variant="primary" as="span" animation="border" role="status" aria-hidden="true" /> :

                            <>
                                {inboxList.length === 0 &&
                                    <div className='empty-data'>
                                        <img className='empty-icon' src={emptybox} alt="empty box icon" />
                                        <h4>No data available</h4>
                                    </div>
                                }
                            </>


                        }
                    


                </div>
            </div>
        </React.Fragment>
    )
}
export default InboxMailList;